/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { DirtyType } from '@gh/common-shared-data';
import { arrayOf, date, DateFormat, entity, enumeration, subentity } from '@gh/core-data';
import { CalendarListItemDto } from './calendar.dto';

export const CalendarMapper = entity({
  dates: arrayOf(subentity<CalendarListItemDto>({
    date: date(DateFormat.Date),
    dirtyType: enumeration(DirtyType),
  })),
});
